import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { isValidElement } from 'react';
import { ConductorBanner } from '../ConductorBanner';
import { ImpBanner } from './ImpBanner';
import { isNotNull } from '@faire/web--source/common/typescriptUtils';
import { AnimatedBanner } from '@faire/retailer/components/AnimatedBanner/AnimatedBanner';
// Hacky way to check if the banner content type based on custom interfaces
var isViewLayoutInterface = function(bannerContent) {
    return bannerContent !== null && (typeof bannerContent === "undefined" ? "undefined" : _type_of(bannerContent)) === 'object' && 'content' in bannerContent;
};
var isProductMessageByViewportInterface = function(bannerContent) {
    return bannerContent !== null && (typeof bannerContent === "undefined" ? "undefined" : _type_of(bannerContent)) === 'object' && 'mobile_and_above' in bannerContent;
};
// This assumes that all banners are merged in the right order
// and this tool is used to render them. If conductor does not return
// any banners, we'll fall back to the PromoBanners component.
export var MixedPromoBanners = function(param) {
    var banners = param.banners;
    var bannerNames = [];
    var bannerComponents = banners.map(function(banner, i) {
        var bannerKey = Object.keys(banner)[0];
        var bannerContent = Object.values(banner)[0];
        if (!bannerKey) {
            return null;
        }
        bannerNames.push(bannerKey);
        switch(true){
            // For now, Conductor only returns ViewLayout for FOI
            // We can cheat a little and just render the ConductorBanner directly
            case isViewLayoutInterface(bannerContent):
                return /*#__PURE__*/ _jsx(ConductorBanner, {
                    overrideViewLayout: bannerContent
                }, i);
            case isProductMessageByViewportInterface(bannerContent):
                return /*#__PURE__*/ _jsx(ImpBanner, {
                    banner: bannerContent
                }, i);
            case /*#__PURE__*/ isValidElement(bannerContent):
                return bannerContent;
            default:
                return null;
        }
    }).filter(isNotNull);
    return /*#__PURE__*/ _jsx(AnimatedBanner, {
        banners: bannerComponents,
        bannerNames: bannerNames
    });
};
